<script setup lang="ts">
import { getPdfUrl } from '@ui/utils/getPdfUrl'

const props = withDefaults(
  defineProps<{
    text?: string
  }>(),
  {
    text: '',
  },
)

const pdfUrl = computed(() => getPdfUrl(props.text))
</script>

<template lang="pug">
UiPdfViewer(
  v-if="pdfUrl"
  errorText="block.term-of-service.pdf_load_error"
  openLabel="block.term-of-service.open_pdf"
  :source="pdfUrl"
)
.rules.m-0.typ-13-17-400(v-else) {{ text }}
</template>

<style scoped>
.rules {
  white-space: pre-line;
  color: var(--cue-content-neutral-secondary);
}
</style>
